import styled from "styled-components";

export default function ButtonStyler(Component) {
  return styled(Component)`
    background-color: #ff6347;
    border: none;
    color: white;
    padding: 10px 10px;
    text-align: center;
    display: inline-block;
    position: absolute;
    right: 50px;
  `;
}
